import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import { ProductStore } from "../ProductStore";
import { validateImageSizes } from "../utils/productModalUtils";

export default function ImageUploader( { fileX, onDeleteImageFromServer } ) {
    const stateSimple = ProductStore.useState( state => state );

    const handleImageChangeSingle = ( e ) => {
        const files = e.target.files;
        const imageError = validateImageSizes( files );
        
        if ( !imageError.error ) {
            ProductStore.update( s => {
                s.imagesLocal = Array.from( files ).concat( Array.from( s.imagesLocal ) );
            } );
        }
    };

    return (
        <section>
            {/* Images from server */}
            {
                stateSimple.imagesServer.map( ( file, i ) => {
                    const image = file;
                    return (
                        <div key={i} className="mb-2 mt-2 d-flex justify-content-between align-content-center align-items-center bg-light">
                            <a
                                href={image.url}
                                target="_blank" 
                                rel="noreferrer"
                            >
                                <img
                                    width={150}
                                    src={image.url}
                                    alt="" />
                            </a>
                            <button
                                onClick={() => { onDeleteImageFromServer( image.id, file ); }}
                                className="btn btn-sm btn-danger">
                                <FontAwesomeIcon icon={faTimes} />
                                <span className="p-1">Quitar Imagen</span>
                            </button>
                        </div>
                    );
                } )
            }
            
            {/* Images local */}
            {
                Array.from( stateSimple.imagesLocal ).map( ( file, i ) => {
                    return (
                        <div key={i} className="mb-2 mt-2 d-flex justify-content-between align-content-center align-items-center bg-light">
                            <a href={URL.createObjectURL( file )} target="_blank" rel="noreferrer">
                                <img width={150} src={URL.createObjectURL( file )} alt="" />
                            </a>
                    
                            <button
                                onClick={() => ProductStore.update( s => {
                                    s.imagesLocal = Array.from( s.imagesLocal ).filter( img => img !== file );
                                } )}
                                className="btn btn-sm btn-danger">
                                <FontAwesomeIcon icon={faTimes} />
                                <span className="p-1">Quitar Imagen</span>
                            </button>
                        </div>
                    );
                } )
            }
            
            {/* Add more images button */}
            {
                ( stateSimple.imagesServer.length + stateSimple.imagesLocal.length ) < 10 ?
                    <div className="p-2 border-1">
                        <label htmlFor={fileX}>
                            <input 
                                style={{ display: "none" }} 
                                id={fileX} 
                                type="file" 
                                multiple 
                                accept="image/png, image/gif, image/jpeg" 
                                onChange={handleImageChangeSingle} 
                            />
                            <div className="btn btn-sm btn-outline-primary">
                                <FontAwesomeIcon className="pr-2" icon={faPlusCircle} />
                                Agregar Imagen
                            </div>
                        </label>
                    </div> : null
            }
        </section> 
    );
}
